import { Helmet } from "react-helmet-async";

const SITE_NAME = "Confidence 2 Create Inc.";
const LOGO_URL = "https://customer-assets.emergentagent.com/job_c2c-nonprofit/artifacts/0drtr76p_c2c.png";

export default function SEO({ title, description, path = "" }) {
  const fullTitle = title ? `${title} | ${SITE_NAME}` : `${SITE_NAME} — Building Stronger Communities`;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={LOGO_URL} />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={LOGO_URL} />
    </Helmet>
  );
}
